import { EventEmitter, Input, Output, ViewChild, Directive } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive()
export class InputWidget {
    @Input() id: number;
    @Input() label: string;
    @Input() required = false;
    @Input() readonly: boolean;

    @Input() set value(val) {
        this.setValue(val);
    }

    get value() {
        return this.getValue();
    }

    @Input() set min(val) {
        this.setMin(val);
    }

    get min() {
        return this._min;
    }

    @Input() set max(val) {
        this.setMax(val);
    }

    get max() {
        return this._max;
    }

    @Output() valueEmitter = new EventEmitter();

    @ViewChild('ip') control;

    _originalValue: any = null;
    _value: any;
    _min: any;
    _max: any;

    input(value) {
        this.valueChanged(value);
    }

    dropTimeFromDate(date: Date): Date {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);
        return newDate;
    }

    isValid() {        
        return (this.control) ? !(this.control.invalid && (this.control.dirty || this.control.touched)) : true;
    }

    valueChanged(value) {
        const dataItem = {
            id: this.id,
            name: this.label,
            value,
            valid: this.isValid(),
            originalValue: this._originalValue,
        };

        // For date fields, we drop the time part and then compare by string and only fire valueEmitter if the value has changed - This is done because
        // the datepicker adds current time to the date which makes the value change and then enables the Dlg Save button when form dialiog has just been openned and 
        // no changes have been made by the user.
        // For other fields, we just fire the valueEmitter. This is needed to make sure forms get updated based on selection of dropdowns
        var OriginalValue = this._originalValue;
        var NewValue = this._value;
        if (OriginalValue instanceof Date && NewValue instanceof Date) {
            OriginalValue = this.dropTimeFromDate(OriginalValue).toDateString()
            NewValue = this.dropTimeFromDate(NewValue).toDateString();

            if (OriginalValue != NewValue) {
                // console.log("Field value changed from " + this._originalValue + " to " + this._value);
                this.valueEmitter.emit(dataItem);
            }
        }
        else {
            // console.log('value changed', dataItem);
            this.valueEmitter.emit(dataItem);
        }
    }

    getValue() {
        return this._value;
    }

    setValue(val) {
        if (this._originalValue == null)
            this._originalValue = val;
        this._value = val;
    }

    setMin(val) {
        this._min = val;
    }

    setMax(val) {
        this._max = val;
    }
}
